// Third party
import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

// Hooks
import { WelcomeController } from '../../../services';

// Components
import { TForgotPasswordRes } from '../../../types/responses';
import { TForgotPasswordReq } from '../../../types/requests';
import { TForgotPasswordProps } from '../../../types';

export function useForgotPasswordAPI({ forgotPassword, reset, }: TForgotPasswordProps) {
  const { enqueueSnackbar } = useSnackbar();

  const resetPasswordAPI = async (data: TForgotPasswordReq) => {
    const payload = { email: data?.email.toLocaleLowerCase() };

    return await WelcomeController().forgotPassword<TForgotPasswordRes>(payload);
  };

  return useMutation({
    mutationFn: resetPasswordAPI,
    onSuccess: async (rsp: any) => {
      if (rsp) {
        enqueueSnackbar('Check your email for reset instructions.', {
          variant: 'success',
        });

        setTimeout(() => {
          forgotPassword.onFalse();
          reset();
        }, 500);
      }
    },
    onError: async () => {
      enqueueSnackbar('Failed to send reset instructions.', {
        variant: 'error',
      });
    },
  });
}
